// extracted by mini-css-extract-plugin
export default {"root":"back-link_root__VUVNd"};